import React, { useEffect, useState } from "react";
import { Box, Flex, Button, ButtonGroup } from "@chakra-ui/react";

import { Newsletter } from "./Newsletter";
import { Social } from "./Social";
import { CityBackground } from "./CityBackground";

export const Secret = () => {
  return (
    <Box>
      <CityBackground />
      <Box zIndex="2" position="fixed" top="50%" w="100%">
        <Newsletter />
      </Box>
      <Flex position="fixed" zIndex="3" bottom="0" right="0" padding="10px">
        <ButtonGroup
          padding="20px"
          borderRadius="12px"
          backdropFilter="blur(12px)"
          p="0px"
        >
          <Social />
        </ButtonGroup>
      </Flex>
    </Box>
  );
};
